<template>
    <section class="section" data-aos="fade" data-aos-duration="2000">
        <div class="container">
            <img class="logo_bk" :src="cover" alt="logo_bk">
            <div class="head__title">
                <transition name="modal">
                    <div  class="head__title_edit">
                        <h2>{{ model.title }}</h2>
                    </div>
                </transition>
            </div>
            <div class="logo">
                <img :src="logo" alt="logo">
            </div>
        </div>
    </section>
</template>

<script>
  export default {
    props: ['model'],
    computed: {
        cover() {
            return this.$apiHost + this.model.animated_image
        },
        logo () {
            return this.$apiHost + this.model.logo
        },
    },
  }
</script>

<style lang="scss" scoped>

    .logo {
        position: absolute;
        display: block;
        box-sizing: border-box;
        clear: both;
        width: 220px;
        bottom: 20px;
        @media screen and (max-width: 1024px) {
            margin: 180px auto 30px auto;
            position: relative;
        }
    }

    .logo_bk {
        display: block;
        box-sizing: border-box;
        position: absolute;
        top: 35%;
        width: auto;
        max-height: 95%;
        left: 26%;
        @media screen and (max-width: 1400px) {
            top: 40%;
            max-height: 90%;
        }
        @media screen and (max-width: 1024px) {
            position: relative;
            top: 120px;
            width: 100%;
            left: 0;
            right: 0;
        }
    }

    .head__title {
        margin-left: 30%;
        margin-right: 10%;
        width: 60%;
        position: relative;
        top: 150px;
        display: block;
        box-sizing: border-box;
        min-height: 100%;
        text-align: left;
        text-transform: uppercase;
        @media screen and (max-width: 1024px) {
            width: 100%;
            margin-right: 30%;
            margin-top: 0;
            text-align: left;
            font-size: 28px;
            margin-left: 0;
        }
        @media screen and (max-width: 800px) {
            width: 100%;
            font-size: 26px;
            padding-right: 15%;
            top: 80px;
            text-align: left;

        }
        @media screen and (max-width: 600px) {
            font-size: 20px;
            padding-right: 0;
            top: 100px;
            text-align: left;
        }
    }

    .head__title h2 {
        font-size: 30px;
        font-family: 'CirceLight', sans-serif;
        font-weight: 100;
        @media screen and (max-width: 1024px) {
            font-size: 28px;
        }
        @media screen and (max-width: 800px) {
            font-size: 26px;
        }
        @media screen and (max-width: 600px) {
            font-size: 20px;
        }
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .head__title_edit,
    .modal-leave-active .head__title_edit {
    }

</style>



// WEBPACK FOOTER //
// src/components/home-page-components/HeadBlock.vue